import { BrandIndexType } from 'common/constants'

enum BrandInitialIndexType {
  KOREAN_INDEX_1 = 'ㄱ',
  KOREAN_INDEX_2 = 'ㄴ',
  KOREAN_INDEX_3 = 'ㄷ',
  KOREAN_INDEX_4 = 'ㄹ',
  KOREAN_INDEX_5 = 'ㅁ',
  KOREAN_INDEX_6 = 'ㅂ',
  KOREAN_INDEX_7 = 'ㅅ',
  KOREAN_INDEX_8 = 'ㅇ',
  KOREAN_INDEX_9 = 'ㅈ',
  KOREAN_INDEX_10 = 'ㅊ',
  KOREAN_INDEX_11 = 'ㅋ',
  KOREAN_INDEX_12 = 'ㅌ',
  KOREAN_INDEX_13 = 'ㅍ',
  KOREAN_INDEX_14 = 'ㅎ',
  ENGLISH_INDEX_1 = 'A',
  ENGLISH_INDEX_2 = 'B',
  ENGLISH_INDEX_3 = 'C',
  ENGLISH_INDEX_4 = 'D',
  ENGLISH_INDEX_5 = 'E',
  ENGLISH_INDEX_6 = 'F',
  ENGLISH_INDEX_7 = 'G',
  ENGLISH_INDEX_8 = 'H',
  ENGLISH_INDEX_9 = 'I',
  ENGLISH_INDEX_10 = 'J',
  ENGLISH_INDEX_11 = 'K',
  ENGLISH_INDEX_12 = 'L',
  ENGLISH_INDEX_13 = 'M',
  ENGLISH_INDEX_14 = 'N',
  ENGLISH_INDEX_15 = 'O',
  ENGLISH_INDEX_16 = 'P',
  ENGLISH_INDEX_17 = 'Q',
  ENGLISH_INDEX_18 = 'R',
  ENGLISH_INDEX_19 = 'S',
  ENGLISH_INDEX_20 = 'T',
  ENGLISH_INDEX_21 = 'U',
  ENGLISH_INDEX_22 = 'V',
  ENGLISH_INDEX_23 = 'W',
  ENGLISH_INDEX_24 = 'X',
  ENGLISH_INDEX_25 = 'Y',
  ENGLISH_INDEX_26 = 'Z',
}

namespace BrandInitialIndexType {
  export const getInitialsByIndexType = (indexType: BrandIndexType) => {
    switch (indexType) {
      case BrandIndexType.KOREAN:
        return [
          BrandInitialIndexType.KOREAN_INDEX_1,
          BrandInitialIndexType.KOREAN_INDEX_2,
          BrandInitialIndexType.KOREAN_INDEX_3,
          BrandInitialIndexType.KOREAN_INDEX_4,
          BrandInitialIndexType.KOREAN_INDEX_5,
          BrandInitialIndexType.KOREAN_INDEX_6,
          BrandInitialIndexType.KOREAN_INDEX_7,
          BrandInitialIndexType.KOREAN_INDEX_8,
          BrandInitialIndexType.KOREAN_INDEX_9,
          BrandInitialIndexType.KOREAN_INDEX_10,
          BrandInitialIndexType.KOREAN_INDEX_11,
          BrandInitialIndexType.KOREAN_INDEX_12,
          BrandInitialIndexType.KOREAN_INDEX_13,
          BrandInitialIndexType.KOREAN_INDEX_14,
        ]
      case BrandIndexType.ENGLISH:
        return [
          BrandInitialIndexType.ENGLISH_INDEX_1,
          BrandInitialIndexType.ENGLISH_INDEX_2,
          BrandInitialIndexType.ENGLISH_INDEX_3,
          BrandInitialIndexType.ENGLISH_INDEX_4,
          BrandInitialIndexType.ENGLISH_INDEX_5,
          BrandInitialIndexType.ENGLISH_INDEX_6,
          BrandInitialIndexType.ENGLISH_INDEX_7,
          BrandInitialIndexType.ENGLISH_INDEX_8,
          BrandInitialIndexType.ENGLISH_INDEX_9,
          BrandInitialIndexType.ENGLISH_INDEX_10,
          BrandInitialIndexType.ENGLISH_INDEX_11,
          BrandInitialIndexType.ENGLISH_INDEX_12,
          BrandInitialIndexType.ENGLISH_INDEX_13,
          BrandInitialIndexType.ENGLISH_INDEX_14,
          BrandInitialIndexType.ENGLISH_INDEX_15,
          BrandInitialIndexType.ENGLISH_INDEX_16,
          BrandInitialIndexType.ENGLISH_INDEX_17,
          BrandInitialIndexType.ENGLISH_INDEX_18,
          BrandInitialIndexType.ENGLISH_INDEX_19,
          BrandInitialIndexType.ENGLISH_INDEX_20,
          BrandInitialIndexType.ENGLISH_INDEX_21,
          BrandInitialIndexType.ENGLISH_INDEX_22,
          BrandInitialIndexType.ENGLISH_INDEX_23,
          BrandInitialIndexType.ENGLISH_INDEX_24,
          BrandInitialIndexType.ENGLISH_INDEX_25,
          BrandInitialIndexType.ENGLISH_INDEX_26,
        ]
      default:
        return []
    }
  }
}

export default BrandInitialIndexType
